import Holdings from '@advisor/models/store/holdings';
import RwHoldingsService from '@advisor/rwSdk/HoldingsService';
import exceptionHandler from '@advisor/util/exceptionHandler';

const sortBySpecs = (tickA, tickB) => tickB.weight - tickA.weight;

// initial state
export const stateObj = function () {
  return new Holdings();
};

// actions
export const actions = {
  async holdingsByClient({commit}, payload) {
    try {
      const sdkResponse = await RwHoldingsService.getHoldingsByClient(payload).catch((error) => {
        throw error;
      });

      return commit('SET_ACOUNT_HOLDINGS_TICKERS', sdkResponse);
    } catch (error) {
      return exceptionHandler.handleGenericException('holdings.holdingsByClient', error, true);
    }
  },
  async updateClientHolding({commit}, payload) {
    try {
      const response = await RwHoldingsService.updateClientHolding(payload).catch((error) => {
        throw error;
      });

      response.index = {ticker: payload.ticker, position: payload.position};

      return commit('UPDATE_ACOUNT_HOLDING_TICKER');
    } catch (error) {
      return exceptionHandler.handleGenericException('holdings.updateClientHolding', error, true);
    }
  },
  async holdingsByTickerIdList({commit}, payload) {
    try {
      const sdkResponse = await RwHoldingsService.getHoldingsByTickerIdList(payload).catch((error) => {
        throw error;
      });

      const data = {data: sdkResponse, index: {ticker: payload.ticker}};

      return commit('UPDATE_ACOUNT_HOLDING_BY_TICKER', data);
    } catch (error) {
      return exceptionHandler.handleGenericException('holdings.holdingsByTickerIdList', error, true);
    }
  },
  /**
   * This returns holding statuses
   * @returns {Array<String>}
   */
  async getHoldingStatuses(_, type) {
    try {
      const sdkResponse = await RwHoldingsService.getMasterHoldingStatuses({
        type,
      }).catch((error) => {
        throw error;
      });

      return sdkResponse;
    } catch (error) {
      exceptionHandler.handleGenericException('holdings.getHoldingStatuses', error);

      return [];
    }
  },
  async updateAssetAllocationForAccountId(context, {accountId}) {
    try {
      return await RwHoldingsService.updateAssetAllocationForAccountId({
        accountId,
        async: true,
      });
    } catch (error) {
      exceptionHandler.handleGenericException('holdings.updateAssetAllocationForAccountId', error);

      return error;
    }
  },
  async updateAssetAllocationForGoalId(context, {goalId}) {
    try {
      return await RwHoldingsService.updateAssetAllocationForGoalId({
        goalId,
        async: true,
      });
    } catch (error) {
      exceptionHandler.handleGenericException('holdings.updateAssetAllocationForGoalId', error);

      return error;
    }
  },
};

// mutations
export const mutations = {
  SET_HOLDINGS(state, payload) {
    state.tickers = payload;
  },
  SET_ACOUNT_HOLDINGS(state, payload) {
    state.tickers = payload;
  },
  SET_ACOUNT_HOLDINGS_TICKERS(state, payload) {
    state.tickers = payload;
    state.tickers.sort(sortBySpecs);
  },
  UPDATE_ACOUNT_HOLDING_TICKER() {
    // eslint-disable-next-line no-param-reassign
  },
  UPDATE_ACOUNT_HOLDING_BY_TICKER(state, payload) {
    const {data, index} = payload;
    const [result] = data;

    state.tickers[index.ticker] = result;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
};
